import React from 'react'
import PersonIcon from '@mui/icons-material/Person';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { Tab, Tabs, Box, Typography } from '@mui/material';
import AddTime from '../add';
import Group from './Group';
function ViewTimeSheet() {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box>
      {/* <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
        indicatorColor="white"
      >
        <Tab
          label={
            <>
              <Box
                sx={{
                  display: "flex",
                  gap: "5px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <PersonIcon
                  sx={{
                    fontSize: "24px",
                    fontWeight: "700",
                    textTransform: "capitalize",
                  }}
                />
                <Typography
                  sx={{
                    fontSize: " 24px",
                    fontWeight: "700",
                    textTransform: "capitalize",
                  }}
                >
                  User
                </Typography>
              </Box>
            </>
          }
          sx={{
            color: "#71A3D6",
            "&.Mui-selected": {
              color: "rgb(16 105 178)",



            },
          }}
        />
        <Tab
          label={
            <>
              <Box
                sx={{
                  display: "flex",
                  gap: "5px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <PeopleAltIcon
                  sx={{
                    fontSize: "24px",
                    fontWeight: "700",
                    textTransform: "capitalize",
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "24px",
                    fontWeight: "700",
                    textTransform: "capitalize",
                  }}
                >
                  Groups
                </Typography>
              </Box>
            </>
          }
          sx={{
            fontSize: "24px",
            color: "#71A3D6",
            fontWeight: "700",
            "&.Mui-selected": {
              color: "rgb(16 105 178)",

            },
          }}
        />

      </Tabs> */}
      <Box sx={{ mt: "2rem" }}>
        {value === 0 && <AddTime value={value} />}
        {/* {value === 1 && <Group value={value} />} */}
      </Box>
    </Box>
  )
}

export default ViewTimeSheet